import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from './auth/login-page';
import { ProtectedRoute } from './shared/protected-route';
import { AdminShell } from './shared/admin-shell';
import { ForbiddenPage, NotFoundPage } from './shared/not-found-page';
import { SuperAdminRoutes } from './super-admin';
import { OrgAdminRoutes } from './org-admin';
import { useAdminAuth } from '@/store/admin/admin-auth-slice';

/**
 * Top-level admin route tree. Mounted at `/admin/*` from the app router.
 *
 *   /admin/login                     — public
 *   /admin/403                       — public, shown when role != allowed
 *   /admin/super/...                 — ProtectedRoute(allowedRoles=[superAdmin])
 *   /admin/org/...                   — ProtectedRoute(allowedRoles=[orgAdmin])
 *   /admin                           — redirects based on role
 */
export function AdminRoutes() {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="403" element={<ForbiddenPage />} />

      <Route element={<ProtectedRoute allowedRoles={['superAdmin']} />}>
        <Route
          path="super/*"
          element={
            <AdminShell>
              <SuperAdminRoutes />
            </AdminShell>
          }
        />
      </Route>

      <Route element={<ProtectedRoute allowedRoles={['orgAdmin']} />}>
        <Route
          path="org/*"
          element={
            <AdminShell>
              <OrgAdminRoutes />
            </AdminShell>
          }
        />
      </Route>

      <Route index element={<RoleRedirect />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

function RoleRedirect() {
  const role = useAdminAuth((s) => s.role);
  if (role === 'superAdmin') return <Navigate to="/admin/super" replace />;
  if (role === 'orgAdmin') return <Navigate to="/admin/org" replace />;
  return <Navigate to="/admin/login" replace />;
}
